import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ScrollReveal from "./ScrollReveal";

const Support = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-primary/90 py-16 px-4 border-y border-border">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        
        {/* Text Section */}
        <div className="flex-1 text-center md:text-left">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl font-bold text-background mb-4">
              Comprehensive Support
            </h2>
          </ScrollReveal>
          
          <ScrollReveal delay={0.1}>
            <p className="text-background text-lg max-w-2xl mx-auto md:mx-0 leading-relaxed">
              From start to finish, our dedicated team is here to assist you every step of the way. Whether you’re navigating complex negotiations or encountering unexpected challenges.
            </p>
          </ScrollReveal>
        </div>
        
        {/* Call to Action Button */}
        <ScrollReveal delay={0.2}>
          <div className="flex-shrink-0 w-full md:w-auto mt-4 md:mt-0">
            <Button 
              size="lg" 
              className="bg-white text-dark w-full md:w-auto text-lg px-8 py-6 h-auto shadow-md hover:scale-105 transition-transform"
              onClick={() => navigate('/contact')}
            >
              Contact Us
            </Button>
          </div>
        </ScrollReveal>

      </div>
    </section>
  );
};

export default Support;